import { Text } from "@overmap-ai/blocks"
import { computeModelIndex, type Procedure } from "@overmap-ai/common"
import { selectProcedureById, selectProcedureTypeById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { useAppSelector } from "../../store"
import type { BaseIndexLabelProps } from "./typings"

interface ProcedureIndexLabelProps extends BaseIndexLabelProps {
	procedureId: Procedure["uuid"]
}

export const ProcedureIndexLabel = memo((props: ProcedureIndexLabelProps) => {
	const { className, procedureId, ...rest } = props

	const procedure = useAppSelector(selectProcedureById(procedureId))

	if (!procedure) {
		throw new Error(`Could not find procedure ${procedureId} in store.`)
	}

	const procedureType = useAppSelector(selectProcedureTypeById(procedure.procedure_type ?? ""))!

	return (
		<Text className={cx("shrink-0 text-nowrap", className)} {...rest}>
			{computeModelIndex(procedureType, procedure)}
		</Text>
	)
})
ProcedureIndexLabel.displayName = "ProcedureIndexLabel"
